import Anvandare from "@/tabs/Admin/Anvandare.vue";
import ForsakringsbolagList from "@/tabs/Admin/ForsakringsbolagList.vue";
import ListAnestesi from "@/tabs/Admin/ListAnestesi.vue";
import ListAnteckningstyp from "@/tabs/Admin/ListAnteckningstyp.vue";
import ListAnvandare from "@/tabs/Admin/ListAnvandare.vue";
import ListBlockad from "@/tabs/Admin/ListBlockad.vue";
import ListDiabetesbehandling from "@/tabs/Admin/ListDiabetesbehandling.vue";
import ListICDKod from "@/tabs/Admin/ListICDKod.vue";
import ListKVAKod from "@/tabs/Admin/ListKVAKod.vue";
import ListLeverantor from "@/tabs/Admin/ListLeverantor.vue";
import ListMaterial from "@/tabs/Admin/ListMaterial.vue";
import ListOpsalar from "@/tabs/Admin/ListOpsalar.vue";
import ListOrgUnit from "@/tabs/Admin/ListOrgUnit.vue";
import ListPatientlage from "@/tabs/Admin/ListPatientlage.vue";
import ListSokord from "@/tabs/Admin/ListSokord.vue";
import ListSokordsstruktur from "@/tabs/Admin/ListSokordsstruktur.vue";
import ListTrombosprofylax from "@/tabs/Admin/ListTrombosprofylax.vue";
import OrgUnit from "@/tabs/Admin/OrgUnit.vue";
import Receptforskrivningsmallar from "@/tabs/Admin/Receptforskrivningsmallar.vue";
import Rollrattigheter from "@/tabs/Admin/Rollrattigheter.vue";
import Sokordsstruktur from "@/tabs/Admin/Sokord.vue";
import AlertInformation from "@/tabs/AlertInformation/AlertInformation.vue";
import AlertInformationForm from "@/tabs/AlertInformation/AlertInformationForm.vue";
import MakuleraAlertInformation from "@/tabs/AlertInformation/MakuleraAlertInformation.vue";
import FilhanteringFiler from "@/tabs/Filhantering/FilhanteringFiler.vue";
import FilhanteringFilval from "@/tabs/Filhantering/FilhanteringFilval.vue";
import FilhanteringGenerellaFiler from "@/tabs/Filhantering/FilhanteringGenerellaFiler.vue";
import Intyg from "@/tabs/Intyg/Intyg.vue";
import IntygsmallForm from "@/tabs/Intyg/IntygsmallForm.vue";
import ListaIntyg from "@/tabs/Intyg/ListaIntyg.vue";
import Journalanteckning from "@/tabs/Journalanteckningar/Journalanteckning.vue";
import JournalAnteckningar from "@/tabs/Journalanteckningar/JournalAnteckningar.vue";
import Journalanteckningsmall from "@/tabs/Journalanteckningmallar/Journalanteckningsmall.vue";
import Journalanteckningsmallar from "@/tabs/Journalanteckningmallar/Journalanteckningsmallar.vue";
import Journalloggar from "@/tabs/Journallogg/Journalloggar.vue";
import LabPortalenInkorg from "@/tabs/LabPortalen/LabPortalenInkorg.vue";
import LabPortalenPatientoversikt from "@/tabs/LabPortalen/LabPortalenPatientoversikt.vue";
import LabPortalenUtkorg from "@/tabs/LabPortalen/LabPortalenUtkorg.vue";
import BaseTab from "@/tabs/mixins/BaseTab";
import HjalpmedelList from "@/tabs/Operation/Admin/HjalpmedelList.vue";
import ListResurs from "@/tabs/Operation/Admin/ListResurs.vue";
import ListStudieKvalitetsregister from "@/tabs/Operation/Admin/ListStudieKvalitetsregister.vue";
import Resurs from "@/tabs/Operation/Admin/Resurs.vue";
import Typoperationer from "@/tabs/Operation/Admin/Typoperationer.vue";
import TypoperationForm from "@/tabs/Operation/Admin/TypoperationForm.vue";
import Operationskalender from "@/tabs/Operation/Kalender/Operationskalender.vue";
import KallelseSend from "@/tabs/Operation/Kallelser/KallelseSend.vue";
import KallelserOchSms from "@/tabs/Operation/KallelserOchSms.vue";
import Operationsanmalan from "@/tabs/Operation/Operationsanmalan.vue";
import Operationsinformation from "@/tabs/Operation/Operationsinformation.vue";
import Operationsjournal from "@/tabs/Operation/Operationsjournal.vue";
import Operationskoordinering from "@/tabs/Operation/Operationskoordinering.vue";
import Operationsoversikt from "@/tabs/Operation/Operationsoversikt.vue";
import Operationsstatistik from "@/tabs/Operation/Operationsstatistik.vue";
import PagaendeOperation from "@/tabs/Operation/PagaendeOperation.vue";
import Preanestesibedomning from "@/tabs/Operation/Preanestesibedomning.vue";
import Preanestesibedomningar from "@/tabs/Operation/Preanestesibedomningar.vue";
import PreanestesibedomningVisa from "@/tabs/Operation/PreanestesibedomningVisa.vue";
import SMSMallar from "@/tabs/Operation/SMS/SMSMallar.vue";
import SMSMallForm from "@/tabs/Operation/SMS/SMSMallForm.vue";
import SMSSend from "@/tabs/Operation/SMS/SMSSend.vue";
import Favorit from "@/tabs/PrescriptionSet/Favorit.vue";
import ListaFavoriter from "@/tabs/PrescriptionSet/ListaFavoriter.vue";
import PrescriptionSet from "@/tabs/PrescriptionSet/PrescriptionSet.vue";
import Samtycke from "@/tabs/Samtycke/Samtycke.vue";
import SamtyckesForm from "@/tabs/Samtycke/SamtyckesForm.vue";
import FormAktivitet from "@/tabs/Skreg/Aktiviter/FormAktivitet.vue";
import ListAktiviteter from "@/tabs/Skreg/Aktiviter/ListAktiviteter.vue";
import FormAktivitetstyp from "@/tabs/Skreg/Aktivitetstyper/FormAktivitetstyp.vue";
import ListAktivitetstyper from "@/tabs/Skreg/Aktivitetstyper/ListAktivitetstyper.vue";
import FormLag from "@/tabs/Skreg/Lag/FormLag.vue";
import ListLag from "@/tabs/Skreg/Lag/ListLag.vue";
import FormPlats from "@/tabs/Skreg/Platser/FormPlats.vue";
import ListPlatser from "@/tabs/Skreg/Platser/ListPlatser.vue";
import Spelare from "@/tabs/Skreg/Spelare/Spelare.vue";
import NarvarostatistikLag from "@/tabs/Skreg/Statistik/NarvarostatistikLag.vue";
import NarvarostatistikSpelare from "@/tabs/Skreg/Statistik/NarvarostatistikSpelare.vue";
import Skadestatistik from "@/tabs/Skreg/Statistik/Skadestatistik.vue";
import FormUnderlag from "@/tabs/Skreg/Underlag/FormUnderlag.vue";
import ListUnderlag from "@/tabs/Skreg/Underlag/ListUnderlag.vue";
import TabContainer from "@/tabs/TabContainer.vue";
import Vardplatsbestallning from "@/tabs/Vardplatsbokning/Vardplatsbestallning.vue";
import Vardplatsbestallningsoversikt from "@/tabs/Vardplatsbokning/Vardplatsbestallningsoversikt.vue";
import Vardplatsdagsoversikt from "@/tabs/Vardplatsbokning/Vardplatsdagsoversikt.vue";
import Vardplatsfakturering from "@/tabs/Vardplatsbokning/Vardplatsfakturering.vue";
import Vardplatskalender from "@/tabs/Vardplatsbokning/Vardplatskalender.vue";
import Vardplatsoversikt from "@/tabs/Vardplatsbokning/Vardplatsoversikt.vue";
import PremedicineringList from "@/tabs/Operation/Admin/PremedicineringList.vue";
import ReceptforskrivningStart from "@/tabs/Receptforskrivning/Start/ReceptforskrivningStart.vue";
import GenomlysningsapparatList from "@/tabs/Operation/Admin/Genomlysningsapparat/GenomlysningsapparatList.vue";
import ListKontaktorsak from "@/tabs/Admin/ListKontaktorsak.vue";
import Patientoversikt from "@/tabs/Patientoversikt/Patientoversikt.vue";
import BesoksmallList from "@/tabs/Admin/Oppenvard/BesoksmallList.vue";
import Besokslista from "@/tabs/Besok/Besokslista/Besokslista.vue";
import BesoksunderlagSkapaRedigera from "@/tabs/Besok/BesoksunderlagSkapaRedigera/BesoksunderlagSkapaRedigera.vue";

export default {
    AlertInformation,
    AlertInformationForm,
    Anvandare,
    BaseTab,
    Favorit,
    FilhanteringFiler,
    FilhanteringFilval,
    FormAktivitet,
    FormAktivitetstyp,
    FormLag,
    FormPlats,
    FormUnderlag,
    Intyg,
    IntygsmallForm,
    Journalanteckning,
    JournalAnteckningar,
    Journalloggar,
    LabPortalenInkorg,
    LabPortalenPatientoversikt,
    LabPortalenUtkorg,
    ListaFavoriter,
    ListaIntyg,
    ListAktiviteter,
    ListAktivitetstyper,
    ListAnteckningstyp,
    ListAnvandare,
    ListICDKod,
    ListKVAKod,
    ListLag,
    ListOrgUnit,
    ListPlatser,
    ListSokord,
    ListSokordsstruktur,
    ListUnderlag,
    MakuleraAlertInformation,
    Operationsanmalan,
    Operationsinformation,
    Operationsjournal,
    Operationskalender,
    Operationskoordinering,
    Operationsoversikt,
    OrgUnit,
    Preanestesibedomning,
    Preanestesibedomningar,
    PreanestesibedomningVisa,
    PrescriptionSet,
    Operationsstatistik,
    Samtycke,
    SamtyckesForm,
    SMSMallar,
    KallelserOchSms,
    Sokordsstruktur,
    Spelare,
    NarvarostatistikLag,
    NarvarostatistikSpelare,
    Skadestatistik,
    TabContainer,
    Typoperationer,
    TypoperationForm,
    Journalanteckningsmallar,
    Journalanteckningsmall,
    PagaendeOperation,
    KallelseSend,
    SMSSend,
    ListResurs,
    Resurs,
    SMSMallForm,
    ListOpsalar,
    ListAnestesi,
    ListBlockad,
    ListPatientlage,
    ListTrombosprofylax,
    ListDiabetesbehandling,
    HjalpmedelList,
    Rollrattigheter,
    ListMaterial,
    ListLeverantor,
    PremedicineringList,
    FilhanteringGenerellaFiler,
    Vardplatsbestallning,
    Vardplatsbestallningsoversikt,
    Vardplatsoversikt,
    ForsakringsbolagList,
    Vardplatsdagsoversikt,
    Vardplatskalender,
    Vardplatsfakturering,
    ReceptforskrivningStart,
    GenomlysningsapparatList,
    ListKontaktorsak,
    ListStudieKvalitetsregister,
    Patientoversikt,
    BesoksmallList,
    Besokslista,
    BesoksunderlagSkapaRedigera,
    Receptforskrivningsmallar,
};
